import Table from "./Table";
import TableContainer from "./TableContainer";
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import TableFooter from "./TableFooter";
import TableRow from "./TableRow";
import TableCell from "./TableCell";
import TablePagination from "./TablePagination";

Table.TableContainer = TableContainer;
Table.TableHead = TableHead;
Table.TableBody = TableBody;
Table.TableFooter = TableFooter;
Table.TableRow = TableRow;
Table.TableCell = TableCell;
Table.TablePagination = TablePagination;

export default Table;
